define(['jquery', 'forms', 'erv_framework', 'erv_triggers', 'erv_formatting', 'erv_translate', 'lazyload', 'ergo_triggers', 'erv_extensions', 'matchheight', 'tagit'],
	function ($, Forms, ERVFramework, ERVTriggers, ERVFormatting, ERVTranslate, LazyLoad, ErgoTriggers) {
		var Common = function () {
			var self = this;
			self.$ervBody = $('#erv-body');

			self.forms = new Forms();
			self.framework = new ERVFramework();
			self.triggers = new ERVTriggers();
			self.formatting = new ERVFormatting();
			self.translate = new ERVTranslate();
			self.ergoTriggers = new ErgoTriggers();

			self.initDataUrl = function($elements) {
				$elements.on('click',
					function(e) {

						// Skip click on links
						if (e.target.tagName.toLowerCase() === 'a') {
							return;
						}

						var url = $(this).data('url');
						if (typeof (url) == "string") {
							e.preventDefault();
							window.location = url;
						}
					});
			};
			
			self.fixAnchorOffset = function() {
				self.$ervBody.find('a[href*="#"]:not([href="#"])').on('click',
					function() {
						if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') ||
							location.hostname === this.hostname) {
							var target = $(this.hash),
								headerHeight = $('header').height() + 20;
							target = target.length ? target : self.$ervBody.find('[name=' + this.hash.slice(1) + ']');

							if (target.length) {
								$('html, body').animate({
										scrollTop: target.offset().top - headerHeight
									},
									400);
								return false;
							}
						}
					});
			};

			self.decimalAdjust = function(type, value, exp) {
				// If the exp is undefined or zero...
				if (typeof exp === 'undefined' || +exp === 0) {
					return Math[type](value);
				}
				value = +value;
				exp = +exp;
				// If the value is not a number or the exp is not an integer...
				if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
					return NaN;
				}
				// Shift
				value = value.toString().split('e');
				value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
				// Shift back
				value = value.toString().split('e');
				return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
			}

			self.overrideMath = function() {
				// Decimal round
				if (!Math.round10) {
					Math.round10 = function (value, exp) {
						return self.decimalAdjust('round', value, exp);
					};
				}
				// Decimal floor
				if (!Math.floor10) {
					Math.floor10 = function (value, exp) {
						return self.decimalAdjust('floor', value, exp);
					};
				}
				// Decimal ceil
				if (!Math.ceil10) {
					Math.ceil10 = function (value, exp) {
						return self.decimalAdjust('ceil', value, exp);
					};
				}
			}
		};

		Common.prototype.sortArrayByName = function ($parent, childrenSelector) {
			$parent.find(childrenSelector).sort(function (a, b) {
				var nameA = a.innerText.toLowerCase(),
					nameB = b.innerText.toLowerCase();
				if(nameA < nameB) {
					return -1;
				}
				return (nameA > nameB) ? 1 : 0
			}).appendTo($parent);
		}

		Common.prototype.initLazyLoad = function(overrideSelector) {
			var self = this, handle = null;

			new LazyLoad({
				elements_selector: '.lazy',
				callback_enter: function (el) {
					$(el).removeClass('loading').addClass('loaded');
				},
				callback_loaded: function (el) {
					if (handle) {
						clearTimeout(handle);
					}

					handle = setTimeout(function () {
						self.framework.equalizeTeasers(overrideSelector);
						handle = null;
					}, 250);
				}
			});
		}
		
		Common.prototype.init = function() {
			var self = this;

			self.overrideMath();

			self.forms.init();

            if (!self.framework.checks.isInEpiEditMode()) {
				self.framework.initPreferredSiteSection();
			}

			self.framework.equalizeTeasers();

			self.initLazyLoad();

			self.initDataUrl(self.$ervBody.find('*[data-url]'));

			self.framework.initTooltips('.tooltip');

			self.translate.initNoTranslate();

			self.fixAnchorOffset();

			self.triggers.init();

			window.ErvCommonUtils = window.ErvCommonUtils || {};
			window.ErvCommonUtils.initTooltips = self.framework.initTooltips;
		}

		return Common;
	});